(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lnr-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lnr-announcement-bar')) {
    customElements.define('lnr-announcement-bar', class extends HTMLElement {
      connectedCallback() {
        this.toggleButton = this.querySelector('.lnr-announcement__toggle');
        if (!this.toggleButton) return;
        this.onToggle = () => {
          const paused = this.toggleButton.getAttribute('aria-pressed') !== 'true';
          this.toggleButton.setAttribute('aria-pressed', String(paused));
          this.dataset.paused = String(paused);
        };
        this.toggleButton.addEventListener('click', this.onToggle);
        this.setAttribute('data-ready', '');
      }

      disconnectedCallback() {
        this.toggleButton?.removeEventListener('click', this.onToggle);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
